import { Button } from 'react-bootstrap';
import { BinIcon, CloseIcon, DividerIcon, DownloadIcon } from '../../../assets/icons';
import React, { useCallback } from 'react';
import prettyBytes from 'pretty-bytes';
import { ProgramAttachment } from '../../types';
import { useAttachmentContent } from '../../hooks/useAttachmentsContent';
import { analyticsTrack } from '../../../web-analytics/webAnalytics';
import { AnalyticsEvent } from '../../../web-analytics/AnalyticsEvent';
import { downloadFile } from '../../../util/file-utils';
import { mobileConfig } from '../../../commons/config';

export const AttachmentCarouselHeader = (props: {
  programId: string;
  attachment: ProgramAttachment;
  onDelete: (attachment: ProgramAttachment) => void;
  onClose: () => void;
}) => {
  const { programId, attachment, onDelete, onClose } = props;

  const { data: attachmentWithContent } = useAttachmentContent(programId, attachment);
  const fileSizeString =
    attachmentWithContent && attachmentWithContent.file
      ? `(${prettyBytes(attachmentWithContent.file.size)})`
      : '';

  const download = useCallback(async () => {
    if (!attachmentWithContent?.url || !attachmentWithContent?.name) return;
    analyticsTrack(AnalyticsEvent.PROGRAM_ATTACHMENT_DOWNLOADED, {
      button: 'header',
    });
    await downloadFile(attachmentWithContent.url, attachmentWithContent.name);
  }, [attachmentWithContent?.url, attachmentWithContent?.name]);
  return (
    <div className="attachments-view__header-container">
      <div className="attachments-view__file-details">
        <div className="attachments-view__file-name" data-test="attachments-view__file-name">
          {attachment.name}
        </div>
        {!!fileSizeString && (
          <div className="attachments-view__file-size" data-test="attachments-view__file-size">
            &nbsp;{fileSizeString}
          </div>
        )}
      </div>
      {attachment.name && !mobileConfig().isMobile && (
        <Button
          className="attachments-view__header-button"
          data-test="attachments-view__download-button"
          onClick={download}
          disabled={!attachmentWithContent?.url}
        >
          <DownloadIcon className="attachments-view__icon" />
        </Button>
      )}
      <Button
        className="attachments-view__header-button"
        data-test="attachments-view__delete-button"
        onClick={() => onDelete(attachment)}
      >
        <BinIcon className="attachments-view__icon" />
      </Button>
      <DividerIcon className="attachments-view__header-divider" />)
      <Button
        className="attachments-view__header-button"
        data-test="attachments-view__close-button"
        onClick={onClose}
      >
        <CloseIcon className="attachments-view__icon" />
      </Button>
    </div>
  );
};
